import get from 'lodash/get';

export function isIOSOrIPadOS() {
  const userAgent = get(global, 'navigator.userAgent', '');
  return isIOS(userAgent) || isIPadOS(userAgent);
}

function isIOS(userAgent) {
  return userAgent.match(/iPhone/i);
}

// https://stackoverflow.com/a/57654258/63011 🤷🏻‍♂️
function isIPadOS(userAgent) {
  if (userAgent.match(/iPad/i)) {
    return true;
  }

  if (userAgent.match(/Macintosh/i)) {
    try {
      document.createEvent('TouchEvent');
      return true;
    } catch (e) {
      return false;
    }
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/utils/deviceDetection.js